/**
 * Access to the admin portal is restricted to Google Workspace accounts on this domain.
 */
export const ALLOWED_EMAIL_DOMAIN = 'foundrastudio.com';

/**
 * Whether an email belongs to the allowed workspace domain.
 *
 * ⚠️ This is a **user-experience affordance, not a security control.**
 *
 * This code runs in the browser, in a bundle any visitor can read and modify.
 * A determined caller simply edits it out. The real restriction has to be
 * enforced by the API on every request, by verifying the Google ID token's
 * signature and its `hd` (hosted domain) claim server-side.
 *
 * Checking `hd` matters specifically: an email ending in "@foundrastudio.com"
 * can be set on a personal Google account, whereas `hd` is asserted by Google
 * for genuine Workspace accounts. Never authorise on the email string alone.
 *
 * Use this only to show a clear message before a request that the API would
 * reject anyway.
 */
export function isAllowedDomain(email: string | undefined): boolean {
  if (!email) return false;
  const at = email.lastIndexOf('@');
  if (at === -1) return false;
  return email.slice(at + 1).toLowerCase() === ALLOWED_EMAIL_DOMAIN;
}
